import React, { useState } from 'react'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { GET, POST, httpOk } from 'helpers/api'

/**
 * Пересчёт себестоимости по техкартам для логина и точки.
 *
 * Логин и точка выбираются списком, а не вводятся руками: id точки админ
 * раньше подсматривал в базе, и опечатка приводила к ошибке «точка не
 * найдена» без подсказки, какие точки вообще есть у этого логина.
 */
function CostPriceTab({ users }) {
	const { t } = useTranslation()

	const [selectedUser, setSelectedUser] = useState(null)
	const [selectedPos, setSelectedPos] = useState(null)
	const [poses, setPoses] = useState([])
	const [result, setResult] = useState(null)

	async function getPoses(login) {
		const response = await GET('/admin/sql/poses', { 'login': login }, { loader: true })
		if (httpOk(response)) setPoses(response.data)
	}

	function handleSelectUser(option) {
		setSelectedUser(option)
		setSelectedPos(null)
		setPoses([])
		setResult(null)
		if (option?.login) getPoses(option.login)
	}

	async function recalculateCostPrices() {
		if (!selectedUser || !selectedPos) {
			toast.error(t('admin_tools_select_login_pos'))
			return
		}

		setResult(null)
		const response = await POST('/admin/recalculate-cost-prices', {
			'login': selectedUser.login,
			'pos_id': Number(selectedPos.id),
		}, { loader: true, notification: false })

		if (httpOk(response)) {
			setResult(response.data)
			toast.success(response.data?.message || t('success'))
		}
	}

	return (
		<div className="row">
			<div className="col-md-6">
				<div className="card">
					<div className="card-body">
						<div className="tool-section-title">
							{t('cost_price')}
						</div>
						<div className="text-muted fz-12 mb-3">
							{t('admin_tools_cost_price_hint')}
						</div>

						<div className="row">
							<div className="form-group col-md-6">
								<label>{t('login')}</label>
								<Select
									options={users}
									value={selectedUser}
									onChange={(option) => handleSelectUser(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => `${option.login} — ${option.name || ''}`}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group col-md-6">
								<label>{t('pos')}</label>
								<Select
									options={poses}
									value={selectedPos}
									onChange={(option) => setSelectedPos(option)}
									isDisabled={!selectedUser}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>

						<button type="button" className="btn btn-warning w-100 mt-2"
							onClick={() => recalculateCostPrices()}>
							{t('admin_tools_recalculate')}
						</button>

						{result &&
							<div className="tool-result mt-3">
								<div className="tool-result-row">
									<span>{t('pos')}</span>
									<b>{result.pos_name}</b>
								</div>
								<div className="tool-result-row">
									<span>{t('admin_tools_products_updated')}</span>
									<b className="text-success">{result.products_updated ?? 0}</b>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default CostPriceTab
